module.exports = "<div *ngIf=\"!isLoading\" [innerHTML]=\"markup\"></div>\n"